import { render, staticRenderFns } from "./bindCPCoop.vue?vue&type=template&id=0b589bb6&scoped=true&"
import script from "./bindCPCoop.vue?vue&type=script&lang=js&"
export * from "./bindCPCoop.vue?vue&type=script&lang=js&"
import style0 from "./bindCPCoop.vue?vue&type=style&index=0&id=0b589bb6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b589bb6",
  null
  
)

export default component.exports